import { useTranslation } from 'react-i18next'

import { FileType } from '@/common/models/files'
import { z } from '@/lib/zod'

export const UploadArchiveSchema = () => {
  const { t } = useTranslation('panel')

  return z.object({
    file: z.instanceof(File, {
      message: t('upload_files.input_upload.error_required'),
    }),
    file_type: z.enum([FileType.ABACO, FileType.CLAIMS, FileType.LUBRIFICANTS]),
  })
}

export type UploadArchiveSchemaForm = z.infer<
  ReturnType<typeof UploadArchiveSchema>
>
